import { ReactNode } from 'react';

import * as styled from './styles';

type Action = {
  label: string;
  onClick: () => void;
};

type Props = {
  /** Emoji or SVG node shown above the title. */
  icon?: ReactNode;
  title?: string;
  body?: string;
  /** Single primary action — usually "Try again" or "Go back". */
  action?: Action;
  /** Renders centered on a full viewport instead of inline. */
  fullPage?: boolean;
  /** Compact inline variant (no icon, smaller spacing) for use inside cards/lists. */
  compact?: boolean;
};

export const EmptyState = ({
  icon,
  title,
  body,
  action,
  fullPage,
  compact,
}: Props) => {
  const Wrap = fullPage
    ? styled.FullPageWrap
    : compact
      ? styled.CompactWrap
      : styled.InlineWrap;

  return (
    <Wrap>
      {icon && !compact ? <styled.Icon>{icon}</styled.Icon> : null}
      {title ? <styled.Title>{title}</styled.Title> : null}
      {body ? <styled.Body>{body}</styled.Body> : null}
      {action ? (
        <styled.ActionButton type="button" onClick={action.onClick}>
          {action.label}
        </styled.ActionButton>
      ) : null}
    </Wrap>
  );
};
